module.exports = __webpack_public_path__ + "static/media/iitdbanner.a5c43b2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/iit/iitdbanner.png
// module id = 448
// module chunks = 1 3